export const FETCH_LOCATION = 'FETCH_LOCATION';
export const FETCH_LOCATION_SUCCESS = 'FETCH_LOCATION_SUCCESS';
export const FETCH_LOCATION_FAILS = 'FETCH_LOCATION_FAILS';

export const FETCH_LOCATION_DETAILS = 'FETCH_LOCATION_DETAILS';
export const FETCH_LOCATION_DETAILS_SUCCESS = 'FETCH_LOCATION_DETAILS_SUCCESS';
export const FETCH_LOCATION_DETAILS_FAILS = 'FETCH_LOCATION_DETAILS_FAILS';
